import { Selector } from "react-redux";
import { RootState } from "../store";
import { CropsInfo } from "@api/socket/WebSocketService";

enum Rotate {
  Row = "row",
  Column = "column"
}

enum Toggler {
  series = "series",
  points = "points"
}

enum Align {
  Center = "center",
  SpaceAround = "spaceAround",
  SpaceBetween = "spaceBetween",
  End = "end",
  Start = "start"
}

enum Color {
  AbsolutelyWhite = "absolutely-white",
  White = "white",
  Ghost = "ghost",
  Gray = "gray",
  LightGray = "light_gray"
}

enum Width {
  Full = "full",
  Auto = "auto",
  Fit = "fit"
}

enum Height {
  Full = "full",
  Auto = "auto"
}

enum TextType {
  Header = "header",
  Text = "text",
  Extra = "extra"
}

enum UnitStatus {
  NoDevice = "NoDevice",
  Work = "Work",
  Moving = "Moving",
  Free = "Free",
  Unauthorized = "Unauthorized",
  Stop = "Stop",
  ConnectionLoss = "ConnectionLoss"
}

type GeoZoneDynamic = {
  cropsInfo: CropsInfo
}

type DynamicUnits = {
  unitState: UnitStatus,
  position: any[]
}

type Crop = {
  id: number | string,
  title: string,
  varieties: string,
  reproduction: string,
  color: number,
  endDate: number
}

type Field = {
  glid: string,
  name: string,
  area: number,
  color: number,
  dynamic?: GeoZoneDynamic,
  manualArea: boolean,
  departmentId: number,
  comment: string,
  zoneType: string
}

type MessageTime = number

type Unit = {
  glid: string,
  name: string,
  typeName: string,
  type: string,
  dynamic: DynamicUnits
}


export {
  Rotate,
  Align,
  Color,
  UnitStatus,
  TextType,
  Width,
  Height,
  Toggler
}

interface ServerResponse<T> {
  [x: string]: any;
  success: boolean,
  data: T
}

export type ServerResponseN<T> = {
  [K in keyof T]: T[K];
};

export type KAryTreeNode<T> = T & { data?: KAryTreeNode<T>[], groupName?: string[] };

export type {
  MessageTime,
  ServerResponse,
  Field,
  Crop,
  GeoZoneDynamic,
  DynamicUnits,
  Unit
}

export type ApiState = { isApiLoading: boolean, apiError: string | undefined}
export type ApiSelect<T> =  Selector<RootState, T & ApiState>
export type ApiStateSelect =  Selector<RootState, ApiState[]>